export default __webpack_public_path__ + "static/media/anniversary2.2b58a657.webp";